import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Text, View, StyleSheet, TouchableOpacity, ActivityIndicator, Platform } from 'react-native';
import {
    Icon,
    Button,
    ButtonTypes,
} from '../../components';
import Theme from '../../theme';
import { FormError } from '../../ui';
import { ActionPanel } from '../../ui/components/ActionPanel';

const isMobile = window.innerWidth <= 550;

const ConfirmationModal = ({
    t,
    leftText = 'No',
    rightText = 'Yes',
    error = {},
    closeModal,
    noHandler,
    yesHandler,
    metaText = '',
    confirmationText,
    isLoading = false,
    isModalVisible = false,
}) => (
        <ActionPanel
            transparent
            animationType="fade"
            onRequestClose={closeModal}
            visible={isModalVisible}>
            <View style={styles.container}>
                <View className="confirmation-modal-inner-container" style={styles.innerContainer}>
                    <View>
                        {isMobile &&
                            <TouchableOpacity
                                style={{ alignSelf: 'flex-end', lineHeight: 20 }}
                                onPress={closeModal}>
                                <Icon
                                    size={35}
                                    name="md-close"
                                    color={Theme.GREY}
                                />
                            </TouchableOpacity>
                        }
                        <Icon
                            style={{
                                alignSelf: 'center',
                                lineHeight: 80,
                            }}
                            size={80}
                            name="ios-alert-outline"
                            color={Theme.PRIMARY}
                        />
                        <Text
                            className="confirmation-heading"
                            style={styles.confirmationText}>
                            {confirmationText}
                        </Text>
                        <Text
                            className="confirmation-meta"
                            style={styles.metaText}>
                            {metaText}
                        </Text>
                        {isLoading ?
                            <ActivityIndicator
                                size="small"
                                color={Theme.PRIMARY}
                                animating={isLoading}
                                style={styles.activityIndicator}
                            />
                            :
                            <View flex={1}>
                                <FormError error={error} />
                                <View style={styles.buttonsContainer}>
                                    <Button
                                        title={leftText}
                                        onPress={noHandler}
                                        containerStyle={styles.noButton}
                                        buttonType={ButtonTypes.OUTLINE}
                                    />
                                    <Button
                                        title={rightText}
                                        onPress={yesHandler}
                                        fontColor={Theme.WHITE}
                                        containerStyle={styles.yesButton}
                                    />
                                </View>
                            </View>
                        }
                    </View>
                </View>
            </View>
        </ActionPanel>
    );

ConfirmationModal.propTypes = {
    metaText: PropTypes.string,
    t: PropTypes.func.isRequired,
    noHandler: PropTypes.func.isRequired,
    yesHandler: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    isModalVisible: PropTypes.bool.isRequired,
    confirmationText: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    innerContainer: {
        flex: 1,
        margin: 15,
        padding: 15,
        marginBottom: 0,
        paddingBottom: 0,
        borderRadius: 10,
        alignItems: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
        backgroundColor: Theme.WHITE,
    },
    confirmationText: {
        fontSize: 25,
        // fontWeight: 300,
        fontFamily:Theme.Custom300,
        textAlign: 'center',
        color: Theme.CHARCOAL,
    },
    metaText: {
        fontSize: 16,
        // fontWeight: 200,
        fontFamily:Theme.Custom200,
        textAlign: 'center',
        paddingVertical: 15,
        color: Theme.GREY_DARK,
    },
    buttonsContainer: {
        flex: 1,
        padding: 15,
        flexDirection: 'row',
    },
    yesButton: {
        flex: 1,
        height: 50,
    },
    noButton: {
        flex: 1,
        height: 50,
        marginRight: 5,
    },
    activityIndicator: {
        paddingVertical: 10,
    },
});

ConfirmationModal.propTypes = {
    t: PropTypes.func.isRequired,
    leftText: PropTypes.string,
    rightText: PropTypes.string,
    error: PropTypes.object,
    closeModal: PropTypes.func.isRequired,
    noHandler: PropTypes.func.isRequired,
    yesHandler: PropTypes.func.isRequired,
    metaText: PropTypes.string,
    confirmationText: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    isModalVisible: PropTypes.bool,
};

export default translate(['home'], { wait: true })(ConfirmationModal);
